import ApiService from "service/Api";
import { CatalogStockPayloadTypes } from "utilities/types/CatalogStock";

const CatalogStockService = {
  getAllCatalogStocks: async (
    catalogId: string,
    page: number,
    search: string,
    limit: number
  ) => {
    const requestData = {
      method: "get",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      params: {
        catalog_id: catalogId,
        page: page,
        search: search,
        per_page: limit,
      },
      url: "admin/catalog-stocks",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  storeCatalogStock: async (payload: CatalogStockPayloadTypes) => {
    const { catalogId, quantity, uniqueCodes, pins, expiryDates } = payload;

    const requestData = {
      method: "post",
      headers: {
        "Content-Type": "application/json; multipart/form-data; charset=utf-8",
      },
      data: {
        catalog_id: catalogId,
        quantity: quantity,
        unique_codes: uniqueCodes,
        pins: pins,
        expiry_dates: expiryDates,
      },
      url: "admin/catalog-stocks",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  updateCatalogStock: async (
    catalogStockId: string,
    payload: CatalogStockPayloadTypes
  ) => {
    const { uniqueCodes, pins, expiryDates } = payload;

    const requestData = {
      method: "post",
      headers: {
        "Content-Type": "application/json; multipart/form-data; charset=utf-8",
      },
      data: {
        unique_code: uniqueCodes,
        pin: pins,
        expiry_date: expiryDates,
        _method: "PUT",
      },
      url: "admin/catalog-stocks/" + catalogStockId,
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  deleteCatalogStock: async (catalogStockId: string) => {
    const requestData = {
      method: "delete",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      url: "admin/catalog-stocks/" + catalogStockId,
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  importCatalogStock: async (catalogId: String, importFile: File) => {
    const requestData = {
      method: "post",
      headers: {
        "Content-Type": "application/json; multipart/form-data; charset=utf-8",
      },
      data: {
        catalog_id: catalogId,
        file: importFile,
      },
      url: "admin/catalog-stocks/import",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },
};

export default CatalogStockService;
